import { BasePagination, PaginableRequest } from 'api/common-schemas';
import { KeyFormType, ApiKeyType, ResponseApiKeyCreate } from './keys.types';
import showToast from 'components/Toast/Toast';
import { apiClient } from 'api/apiClient';

export const copyText = (title: string, text: string, name: string) =>
  navigator.clipboard.writeText(text).then(() => {
    showToast.confirmation({
      title: title,
      message: name,
    });
  });

export const getKeys = async (
  args: PaginableRequest,
): Promise<BasePagination<ApiKeyType>> => {
  const response = await apiClient.get('/api/v1/tokens', {
    params: {
      ...args,
    },
  });
  return response.data;
};

export const getKeyById = async (
  client_id: string,
): Promise<ApiKeyType | undefined> => {
  const response = await apiClient.get(`/api/v1/tokens/${client_id}`);
  return response.data;
};

export const deleteKey = async (
  client_id: string,
): Promise<ApiKeyType | undefined> => {
  const response = await apiClient.delete(`/api/v1/tokens/${client_id}`);
  return response.data;
};

export const regenerateKey = async (
  client_id: string,
  body: KeyFormType,
): Promise<ResponseApiKeyCreate | undefined> => {
  await deleteKey(client_id);
  return postKey(body);
};

export const postKey = async (
  body: KeyFormType,
): Promise<ResponseApiKeyCreate | undefined> => {
  const response = await apiClient.post('/api/v1/tokens', {
    ...body,
    scopes: [
      'urn:grt:accessexpress',
      'urn:grt:techexpress',
      'urn:grt:nocexpress',
    ],
  });
  return response.data;
};
